import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-398">
      <div className="max-w-5xl mx-auto" data-id="element-399">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-400">
          Lo que <span className="text-[#00B4D8]" data-id="element-401">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-402">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-403">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-404">
              🇫🇷 A1.1 → B1 — 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-405">
              Para docentes de Francés de todos los niveles e institutos
            </p>
            <div className="space-y-4" data-id="element-406">
              <div className="flex items-center gap-3 text-white" data-id="element-407">
                <span className="text-xl" data-id="element-408">📘</span>
                <div className="flex-1" data-id="element-409">
                  <span className="font-bold" data-id="element-410">Tomo 1 — A1.1: El Despertar</span>
                  <span className="text-gray-300" data-id="element-411">
                    {' '}
                    Saludos, identidad, familia, rutinas. ÊTRE, AVOIR y verbos
                    en -ER.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-412">
                <span className="text-xl" data-id="element-413">📗</span>
                <div className="flex-1" data-id="element-414">
                  <span className="font-bold" data-id="element-415">
                    Tomo 2 — A1.2: La Consolidación
                  </span>
                  <span className="text-gray-300" data-id="element-416">
                    {' '}
                    Cuerpo, compras, casa, alimentos. Partitivos y verbos
                    impersonales.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-417">
                <span className="text-xl" data-id="element-418">📙</span>
                <div className="flex-1" data-id="element-419">
                  <span className="font-bold" data-id="element-420">Tomo 3 — A2: La Autonomía</span>
                  <span className="text-gray-300" data-id="element-421">
                    {' '}
                    Passé composé, imparfait, viajes, tecnología. Verbos
                    pronominales.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-422">
                <span className="text-xl" data-id="element-423">📕</span>
                <div className="flex-1" data-id="element-424">
                  <span className="font-bold" data-id="element-425">
                    Tomo 4 — B1: La Interacción Real
                  </span>
                  <span className="text-gray-300" data-id="element-426">
                    {' '}
                    Subjonctif, conditionnel, debate, cultura. Pronombres
                    relativos y discours indirect.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-427">
                <span className="text-xl" data-id="element-428">📓</span>
                <div className="flex-1" data-id="element-429">
                  <span className="font-bold" data-id="element-430">
                    Tomo 5 — Todos los Niveles: La Valija de Juegos
                  </span>
                  <span className="text-gray-300" data-id="element-431">
                    {' '}
                    80 dinámicas listas: vocabulario, gramática, oralidad,
                    cultura. Sin tecnología.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-432">
                <span className="text-xl" data-id="element-433">📔</span>
                <div className="flex-1" data-id="element-434">
                  <span className="font-bold" data-id="element-435">Tomo 6 — Gestión Total</span>
                  <span className="text-gray-300" data-id="element-436">
                    {' '}
                    24 exámenes, rúbricas, planificaciones, planillas, informes
                    y Solucionario Maestro.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-437">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-438">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-439">
            <div className="flex items-start gap-2 text-left" data-id="element-440">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-441">✅</span>
              <span className="text-white text-sm" data-id="element-442">
                Planificación anual lista + secuencias didácticas completas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-443">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-444">✅</span>
              <span className="text-white text-sm" data-id="element-445">
                6 bloques temáticos con actividades fotocopiables
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-446">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-447">✅</span>
              <span className="text-white text-sm" data-id="element-448">
                Evaluaciones + rúbricas + criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-449">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-450">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-451">
                SOLUCIONARIO COMPLETO con respuestas y justificaciones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-452">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-453">✅</span>
              <span className="text-white text-sm" data-id="element-454">
                Errores de interferencia español-francés + conexión cultural
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-455">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-456">✅</span>
              <span className="text-white text-sm" data-id="element-457">
                100% alineado al MCER · Francés moderno y real
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}